import { render } from "./voteReward.vue?vue&type=template&id=0df523a7&scoped=true"
import script from "./voteReward.vue?vue&type=script&lang=js"
export * from "./voteReward.vue?vue&type=script&lang=js"

import "./voteReward.vue?vue&type=style&index=0&id=0df523a7&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df523a7"]])

export default __exports__